(function () {
  if (customElements.get("accordion-component")) {
    return;
  }

  class AccordionComponent extends HTMLElement {
    constructor() {
      super();
      this.bindEvents();
    }

    bindEvents() {
      this.addEventListener("click", (event) => {
        event.preventDefault();
        const clickedTitle = event.target.closest(".accordion-component__item-title");
        if (!clickedTitle) return;

        const clickedItem = clickedTitle.parentElement;
        
        // Toggle active class on clicked item
        clickedItem.classList.toggle("is-active");

        // Remove active class from siblings
        const siblings = Array.from(this.querySelectorAll(".accordion-component__item"));
        siblings.forEach(item => {
          if (item !== clickedItem) {
            item.classList.remove("is-active");
          }
        });
      });
    }
  }

  customElements.define("accordion-component", AccordionComponent);
})();
